// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1F-Xr","footer":"ModalInfo_footer__5EBdd"};